import React, { useState, useContext, useEffect } from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";
import MobileContext from "../context";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { getJob, getEmpAct } from "../../../api/index";

const bList = [
  {
    img: require("assets/joinus/b1.png"),
    title: "$singlee_ju14",
    desc: "$singlee_ju15",
  },
  {
    img: require("assets/joinus/b2.png"),
    title: "$singlee_ju16",
    desc: "0571-88480666",
  },
  {
    img: require("assets/joinus/b3.png"),
    title: "$singlee_ju17",
    desc: "310030",
  },
  {
    img: require("assets/joinus/b4.png"),
    title: "$singlee_ju18",
    desc: "0571-89712755",
  },
  {
    img: require("assets/joinus/b5.png"),
    title: "$singlee_ju19",
    desc: "0571-89712758",
  },
];

function Index() {
  const { t } = useTranslation();
  const [picIndex, setPicIndex] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [inviteList, setInviteList] = useState([]);
  const [picList, setPicList] = useState([]);
  const mobile = useContext(MobileContext);

  const [firtstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
      config: { duration: 300 },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [thirdRef, thirdRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [fourthRef, fourthRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.4, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  useEffect(() => {
    getJobList();
    getPicList();
  }, []);

  const prev = () => {
    if (picIndex === 0) {
      setPicIndex(picList.length - 1);
    } else {
      setPicIndex(picIndex - 1);
    }
  };
  const next = () => {
    if (picIndex === picList.length - 1) {
      setPicIndex(0);
    } else {
      setPicIndex(picIndex + 1);
    }
  };
  const getJobList = async () => {
    const res = await getJob({ pageNum: 1, pageSize: 999 });
    if (res.code === 200) {
      setInviteList(res.data.list);
    }
  };
  const getPicList = async () => {
    const res = await getEmpAct();
    if (res.code === 200) {
      setPicList(res.data);
    }
  };

  return (
    <div className={css.contain}>
      {previewUrl ? (
        <div
          className={css.preview}
          onClick={() => setPreviewUrl(null)}
          style={{ height: `${window.innerHeight}px` }}
        >
          <img src={previewUrl} alt="" />
        </div>
      ) : null}
      <div className={css.maintitle}>{t("$singlee_ju1")}</div>
      <div className={css.first} ref={firtstRef}>
        <animated.div style={firstRefStyle} className={css.firstInner}>
          {inviteList.map((item, index) => {
            return (
              <InviteBox item={item} index={index} key={index}></InviteBox>
            );
          })}
        </animated.div>
      </div>

      <div className={css.maintitle}>{t("$singlee_ju2")}</div>
      <div className={css.second} ref={secondRef}>
        <animated.div style={secondRefStyle} className={css.inner}>
          <div className={css.top}>
            <div className={css.item} style={{ marginRight: "50px" }}>
              <div className={`${css.icon} ${css.lxr}`}></div>
              <div className={css.title}>{t("$singlee_ju3")}</div>
              <div className={css.desc}>{t("$singlee_ju4")}</div>
            </div>
            <div className={css.item}>
              <div className={`${css.icon} ${css.mail}`}></div>
              <div className={css.title}>{t("$singlee_ju5")}</div>
              <div className={css.desc}>{t("shengwq@singlee.com.cn")}</div>
            </div>
          </div>
          <div className={css.bot}>
            <div className={css.item}>
              <div className={css.picbox}>
                <img src={require("../../../assets/joinus/m1.png")} alt="" />
              </div>
              <div className={css.desc}>{t("$singlee_ju6")}</div>
            </div>
            <div className={css.item}>
              <div className={css.picbox}>
                <img src={require("../../../assets/joinus/m2.png")} alt="" />
              </div>
              <div className={css.desc}>{t("$singlee_ju7")}</div>
            </div>
            <div className={css.item}>
              <div className={css.picbox}>
                <img src={require("../../../assets/joinus/m3.png")} alt="" />
              </div>
              <div className={css.desc}>{t("$singlee_ju8")}</div>
            </div>
            <div className={css.item}>
              <div className={css.picbox}>
                <img src={require("../../../assets/joinus/m4.png")} alt="" />
              </div>
              <div className={css.desc}>{t("$singlee_ju9")}</div>
            </div>
            <div className={css.item}>
              <div className={css.picbox}>
                <img src={require("../../../assets/joinus/m5.png")} alt="" />
              </div>
              <div className={css.desc}>{t("$singlee_ju10")}</div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.third} ref={thirdRef}>
        <div className={css.maintitle}>{t("$singlee_ju11")}</div>
        <animated.div className={css.inner} style={thirdRefStyle}>
          {mobile ? (
            <Swiper
              pagination={{ bulletActiveClass: css.currentClass }}
              slidesPerView={1}
              spaceBetween={30}
              grabCursor={true}
              modules={[Pagination]}
              className={css.cardSwiper}
            >
              {picList.map((item, index) => {
                return (
                  <SwiperSlide
                    className={`${css.cardboxOut}`}
                    key={index}
                    onClick={() => setPreviewUrl(item.img)}
                  >
                    <div className={css.item}>
                      <div className={css.picbox}>
                        <img src={item.imgUrl} alt="" />
                      </div>
                      <div className={css.desc}>{t(item.title)}</div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <>
              <div className={css.box}>
                <div
                  className={`${css.item} ${css.left}`}
                  onClick={() =>
                    setPreviewUrl(
                      picList[
                        picIndex === 0 ? picList.length - 1 : picIndex - 1
                      ].imgUrl
                    )
                  }
                >
                  <div className={css.picbox}>
                    <img
                      src={
                        picList[
                          picIndex === 0 ? picList.length - 1 : picIndex - 1
                        ] &&
                        picList[
                          picIndex === 0 ? picList.length - 1 : picIndex - 1
                        ].imgUrl
                      }
                      alt=""
                    />
                  </div>
                  <div className={css.desc}>
                    {t(
                      picList[
                        picIndex === 0 ? picList.length - 1 : picIndex - 1
                      ] &&
                        picList[
                          picIndex === 0 ? picList.length - 1 : picIndex - 1
                        ].title
                    )}
                  </div>
                </div>
                <div className={css.arrow}>
                  <div className={css.left} onClick={prev}></div>
                </div>
                <div
                  className={css.item}
                  onClick={() => setPreviewUrl(picList[picIndex].imgUrl)}
                >
                  <div className={css.picbox}>
                    <img
                      src={picList[picIndex] && picList[picIndex].imgUrl}
                      alt=""
                    />
                  </div>
                  <div className={css.desc}>
                    {picList[picIndex] && picList[picIndex].title}
                  </div>
                </div>
                <div className={css.arrow}>
                  <div className={css.right} onClick={next}></div>
                </div>
                <div
                  className={`${css.item} ${css.right}`}
                  onClick={() =>
                    setPreviewUrl(
                      picList[
                        picIndex === picList.length - 1 ? 0 : picIndex + 1
                      ].imgUrl
                    )
                  }
                >
                  <div className={css.picbox}>
                    <img
                      src={
                        picList[
                          picIndex === picList.length - 1 ? 0 : picIndex + 1
                        ] &&
                        picList[
                          picIndex === picList.length - 1 ? 0 : picIndex + 1
                        ].imgUrl
                      }
                      alt=""
                    />
                  </div>
                  <div className={css.desc}>
                    {t(
                      picList[
                        picIndex === picList.length - 1 ? 0 : picIndex + 1
                      ] &&
                        picList[
                          picIndex === picList.length - 1 ? 0 : picIndex + 1
                        ].title
                    )}
                  </div>
                </div>
              </div>
              <div className={css.pagination}>
                {picList.map((_, index) => {
                  return (
                    <div
                      className={`${css.dot} ${
                        picIndex === index ? css.active : ""
                      }`}
                      key={index}
                    ></div>
                  );
                })}
              </div>
            </>
          )}
        </animated.div>
      </div>

      <div className={css.maintitle}>{t("$singlee_ju12")}</div>
      <div className={css.fourth} ref={fourthRef}>
        <animated.div className={css.inner} style={fourthRefStyle}>
          <div className={css.left}>
            {/* <Map
              center={{ lng: 120.081488, lat: 30.322834 }}
              enableScrollWheelZoom
              zoom={18}
              tilt={40}
              style={{ width: "100%", height: "240px" }}
            >
              <Marker
                position={{ lng: 120.081488, lat: 30.322834 }}
                enableDragging
              />
            </Map> */}
          </div>
          <div className={css.right}>
            <div className={css.top}>{t("$singlee_ju13")}</div>
            <div className={css.bot}>
              {bList.map((item, index) => {
                return (
                  <div className={css.item} key={index}>
                    <div className={css.icon}>
                      <img src={item.img} alt="" />
                    </div>
                    <div className={css.title}>{t(item.title)}</div>
                    <div className={css.desc}>{t(item.desc)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </animated.div>
      </div>
    </div>
  );
}

const InviteBox = React.memo(({ item, index }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  return (
    <div
      className={`${css.invitebox} ${show ? css.showbox : ""}`}
      key={index}
      style={{ borderTop: index === 0 ? "" : "none" }}
    >
      <div className={css.top}>
        <div className={css.box}>
          <div className={css.left}>
            <div className={css.flextop}>
              <div className={css.name}>{t(item.jobName)}</div>
              <div className={css.time}>
                {item.jobDate ? item.jobDate.split(" ")[0] : "--"}
              </div>
            </div>
            <div className={css.flexbot}>
              <div className={css.item}>学历：{t(item.jobLevel)}</div>
              <div className={css.item}>工龄：{t(item.jobAge)}</div>
              <div className={css.item}>性别：{t(item.jobSex)}</div>
              <div className={css.item}>地点：{t(item.jobLocal)}</div>
            </div>
          </div>
          <div
            className={`${css.show} ${show ? css.close : ""}`}
            onClick={() => setShow(!show)}
          ></div>
        </div>
      </div>
      <div className={`${css.bot} ${show ? "" : css.none}`}>
        <div className={css.desc}>
          <div>岗位职责</div>
          {item.jobDuty}
          <br />
          <br />
          <div>任职要求</div>
          {item.jobNr}
        </div>
      </div>
    </div>
  );
});

export default React.memo(Index);
